import '../styles/LandingPage.css';
import romaLogo from "../images/roma-logo.png"
import fbo from "../images/facebook_logo_w.png"
import ins from "../images/instagram_logo_w.png"
import twi from "../images/twitter_logo_w.png"

function LandingPage() {
  return (
    <div className="landing-page-container">
      <div className="panel-1">
        <div className="landing-page-roma-logo-container">
          <a className="a-landing" href="/home">
            <img className="roma-logo" src={romaLogo} alt="Roma logo" />
          </a>
        </div>

        <div className="lp-button-container" >
          <button className="menu-button" onClick={(e) => {
            e.preventDefault();
            window.location.href="/dining";
            }} >Menu
          </button>
          
          <button className="order-now-button" onClick={(e) => {
            e.preventDefault();
            localStorage.removeItem("token")
            window.location.href="/order/dining";
            }} >Order Now
          </button>
        </div>

        <div className="landing-page-contact-info">
          <span>Federal Hill</span>
          <span>310 Atwells Ave.</span>
          <span>Providence, RI</span>
          <span>Mngr: Oliver Aldana</span>
          <span>(401)331-5000</span>
          <span>Romaonthehill@gmail.com</span>
        </div>

        <div className="social-media" >
          <a className="social-media-a" href="https://www.facebook.com/romaprov/" target="_blank" rel="noreferrer" >
            <img className="social-media-img" src={fbo} alt="Facebook link" />
          </a>
          <a className="social-media-a" href="https://www.instagram.com/romapvd/?hl=en" target="_blank" rel="noreferrer" >
            <img className="social-media-img" src={ins} alt="Instagram link" />
          </a>
          <a className="social-media-a" href="https://twitter.com/romaprovidence" target="_blank" rel="noreferrer" >
            <img className="social-media-img" src={twi} alt="Twitter link" />
          </a>
        </div>
      </div>

      <div className="panel-2">
        <div className="landing-tab market" >
          <div className="lt-nameplate" onClick={(e) => {
            e.preventDefault();
            window.location.href="/dining";
          }}>
            <span>Pizza / Deli / </span><br/>
            <span>Market</span>
          </div>          
        </div>

        <div className="landing-tab bakery" >
          <div className="lt-nameplate" onClick={(e) => {
            e.preventDefault();
            window.location.href="/dining";
          }}>
            <span>Coffee Bar / Bakery / </span><br/>
            <span>Gelato</span>
          </div>
        </div>

        <div className="landing-tab dining" >
          <div className="lt-nameplate" onClick={(e) => {
            e.preventDefault();
            window.location.href="/catering";
          }}>
            <span>Catering</span>
          </div>          
        </div>
        
        <div className="landing-tab banquet" >
          <div className="lt-nameplate" onClick={(e) => {
            e.preventDefault();
            window.location.href="/catering";
          }}>
            <span>Banquet Hall</span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default LandingPage
